module.exports = __webpack_public_path__ + "img/kuwait.8d3bb40.webp";